import { useCallback } from 'react';
import { QuoteAddress } from '~/lib/types/basket-types';
import useSavedAddresses from './use-saved-addresses';
import useBasketSection from './use-basket-section';
import { BasketSections } from '~/lib/types/enums';
import { useSavedAddressPersister } from './use-saved-address-persister';
import { useAuth } from 'react-oidc-context';

const useSenderSavedAddressPersister = () => {
  const { isAuthenticated } = useAuth();
  const origin = useBasketSection<QuoteAddress>({ name: BasketSections.ORIGIN });
  const { defaultAddress } = useSavedAddresses(origin.data.country, '');
  const { saveAddress } = useSavedAddressPersister();

  const persistSenderAddress = useCallback(() => {
    try {
      if (!isAuthenticated || defaultAddress || !origin.data?.contactname) {
        return;
      }
      return saveAddress(origin.data, true);
    } catch (e) {
      console.error(e);
    }
  }, [isAuthenticated, defaultAddress, origin, saveAddress]);

  return {
    persistSenderAddress: persistSenderAddress
  };
};

export default useSenderSavedAddressPersister;
